<template>
  <div class="c-field-base" :class="styles">
    <div class="c-field-base_container">
      <div v-if="label" class="c-field-base_label">
        <label :for="name" v-html="label" />
      </div>
      <p v-if="description" class="c-field-base_description">
        {{ description }}
      </p>
      <div class="c-field-base_box" :class="sizeStyles">
        <div v-if="loading" class="c-field-base_spinner">
          <svg
            class="c-field-base_icon"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="40px"
            height="40px"
            viewBox="0 0 50 50"
            style="enable-background: new 0 0 50 50"
            xml:space="preserve"
          >
            <path
              d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
            >
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
          </svg>
        </div>
        <slot name="field" :field-type="fieldType" />
        <div v-if="helperControl" class="c-field-base_btn-control">
          <Btn
            v-tooltip="{
              content: helperMessage,
              delay: 0,
              trigger: 'hover focus click',
            }"
            rounded
            class="v--flushed"
            @click.prevent.stop
          >
            <SvgSymbol size="20" name="help-circle" />
          </Btn>
        </div>
        <div v-if="passwordControl" class="c-field-base_btn-control">
          <Btn
            rounded
            class="v--flushed"
            @click.prevent.stop="passwordVisible = !passwordVisible"
          >
            <SvgSymbol size="20" :name="passwordControlIcon" />
          </Btn>
        </div>
      </div>
    </div>
    <span v-if="sublabel" class="c-field-base_sublabel">
      {{ sublabel }}
    </span>
    <span v-if="showErrorMessage && errorMessage" class="c-field-base_message">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'FieldBase',
  props: {
    name: {
      type: String,
      default: 'name',
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    sublabel: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isErrorChecked: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: 'Faltou preencher aqui.',
    },
    helperMessage: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      default: 'text',
    },
    showPasswordControl: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => {
        return ['small', 'medium', 'large'].includes(value)
      },
    },
  },
  data() {
    return {
      passwordVisible: false,
    }
  },
  computed: {
    showErrorMessage() {
      return (
        (this.hasError && this.isErrorChecked === null) ||
        (this.isErrorChecked && this.hasError)
      )
    },
    helperControl() {
      return Boolean(this.helperMessage)
    },
    passwordControl() {
      return this.inputType === 'password' && this.showPasswordControl
    },
    passwordControlIcon() {
      return this.passwordVisible ? 'eye-off' : 'eye'
    },
    fieldType() {
      if (this.inputType === 'password' && this.passwordVisible) {
        return 'text'
      }
      return this.inputType
    },
    sizeStyles() {
      return {
        [`v--${this.size}`]: true,
      }
    },
    styles() {
      return {
        'v--has-error': this.showErrorMessage,
        'v--has-loader': this.loading,
        'v--has-btn-control': this.passwordControl || this.helperControl,
      }
    },
  },
}
</script>

<style lang="stylus" src="./style.styl" scoped></style>
